<template>
  <radio-group v-model="model.encryption" inline>
    <radio
      :border="true"
      :label="1"
      :title="$t('CampaignForm_Setup_DefaultEncryption_Title')"
      :description="$t('CampaignForm_Setup_DefaultEncryption_Description')"
      data-qa="encryption-use-where-possible-checkbox"
    />
    <radio
      :border="true"
      :label="2"
      :title="$t('CampaignForm_Setup_EnforceEncryption_Title')"
      :description="$t('CampaignForm_Setup_EnforceEncryption_Description')"
      data-qa="encryption-enforce-checkbox"
    />
  </radio-group>
</template>

<script>
import RadioGroup from '@/common/components/form/RadioGroup'
import Radio from '@/common/components/form/Radio'
export default {
  name: 'MessageEncryption',
  components: {
    RadioGroup,
    Radio
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/segment/MessageEncryption.vue